import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import TopMenu from "../../../../Components/TopMenu/TopMenu";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';

import VehicleView from './VehicleView.js';
import OrdersView from './OrdersView.js';
import AwbView from './AwbView.js';

import { Modal, Button, Dropdown, Row, Col, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faFilter, faDownload } from '@fortawesome/free-solid-svg-icons';

import Export from "../../../../assets/images/export.svg";
import Exportw from "../../../../assets/images/exportw.png";
import Reset from "../../../../assets/images/reset_w.png";
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { GETDESTINATION, MONITORLOADINGSTATION, MONITORUNLOADINGSTATION, TRUCKERSEARCH, TRUCKORDERSDETAILS } from '../../../../Utils/conts.js';
import DownloadGrid from '../common/DownloadGrid.js';

const TruckMonitor = () => {
    const options = [];
    const user = localStorage.getItem('RFS');
    const initialTab = localStorage.getItem("Htab") || 'orders';
    const intialB = user ? 'orders' : 'vehicle';
    const [selectedButton, setSelectedButton] = useState(initialTab);
    const handleButtonClick = (button) => {
        setSelectedButton(button);
        localStorage.setItem('Htab', button);
        if (button == "orders") {
            loadStation();
        }
    };
    useEffect(() => {
        setSelectedButton(initialTab);
        if (initialTab == "orders") {
            loadStation();
        }
    }, [initialTab]);

    const isMounted = useRef(false);
    const [getLoadingStn, setGetLoadingStn] = useState([]);
    const [getUnLoadingStn, setGetUnLoadingStn] = useState([]);
    const [filterData, setFilterData] = useState({});
    const [orderType, setOrderType] = useState('Loading');
    const [searchData, setSearchData] = useState({ search_area: '', o_id: '' });
    const [searchItems, setSearchItems] = useState([]);
    const [applyFilter, setApplyFilter] = useState(false);
    const [resetFilter, setResetFilter] = useState(false);
    const [resetFilters, setResetFilters] = useState(false);
    const [selectedLLocation, setSelectedLLocation] = useState([]);
    const [selectedULocation, setSelectedULocation] = useState([]);
    const [stationlist, setStationlist] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);
    const clearSearch = () => {
        setSearchData({ search_area: '', o_id: '' })
    }
    const clearFilter = () => {
        const cleanedFilterData = cleanFilterData2(filterData);
        setFilterData(cleanedFilterData);
        // setFilterData({})
        setApplyFilter(true);
    }
    const handleSearchChange = (event) => {
        const { name, value } = event.target;
        setSearchData(prevData => ({
            ...prevData,
            [name]: value,
            ...(name === 'search_area' && { o_id: '' }) // Reset `o_id` if `search_area` changes
        }));
    }

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilterData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }
    function cleanFilterData2(data) {
        const cleanedData = {};

        Object.keys(data).forEach((key) => {
            const value = data[key];

            // Include all keys but reset their values
            if (Array.isArray(value)) {
                cleanedData[key] = []; // Reset arrays to empty
            } else if (typeof value === "string") {
                cleanedData[key] = ''; // Reset strings to empty
            } else {
                cleanedData[key] = ''; // Reset other types to null
            }
        });

        return cleanedData;
    }
    function cleanFilterData(data) {

        const cleanedData = {};

        Object.keys(data).forEach((key) => {
            const value = data[key];

            // Only include keys with non-empty values
            if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
                cleanedData[key] = value;
            }
        });

        console.log("check this shit", cleanedData)
        return cleanedData;
    }
    const handleApplyFilter = () => {
        const cleanedFilterData = cleanFilterData(filterData);
        setFilterData(filterData);
        setApplyFilter(true); // Trigger filter application in the child
        setResetFilter(true);
        setResetFilters(false);
    };
    const handleResetFilter = () => {
        setResetFilter(false);
        setResetFilters(true);
        const cleanedFilterData = cleanFilterData2(filterData);
        setFilterData(cleanedFilterData);
        // setFilterData({})
        // setApplyFilter(true);
    }

    const fetchLoadingStn = async () => {
        try {

            const res = await withRFSToken.post(MONITORLOADINGSTATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetLoadingStn(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchUnLoadingStn = async () => {
        try {

            const res = await withRFSToken.post(MONITORUNLOADINGSTATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetUnLoadingStn(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchSearchData = async () => {
        try {

            const res = await withRFSToken.post(TRUCKERSEARCH, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSearchItems(innerData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleSearch = async () => {
        try {
            const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: searchData.o_id });
            // .then(function (res) {
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // setSelectedRowData(innerData);
                // setDisLoading(false);
                localStorage.removeItem('OVDetails');
                const storageData = {
                    ULD: innerData,  // ULD Details section
                    Form: {}  // Empty form section
                };
                localStorage.setItem('OVDetails', JSON.stringify(storageData));
                // localStorage.setItem('tab', 'assets');
                window.location.href = '/HandlerTruckMonitor/OrdersViewDetails'
            } else {
                // toast.error('No Details found');
                // setDisLoading(false);
            }

            // });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // try {
        //     // Check if selectedRowData is defined
        //     if (!selectedRowData) {
        //         throw new Error('Selected row data is not available.');
        //     }

        //     localStorage.removeItem('OVDetails');
        //     const storageData = {
        //         ULD: selectedRowData,  // ULD Details section
        //         Form: {}  // Empty form section
        //     };
        //     localStorage.setItem('OVDetails', JSON.stringify(storageData));
        //     // localStorage.setItem('tab', 'assets');
        //     window.location.href = '/TruckMonitor/OrdersViewDetails'
        // } catch (error) {
        //     // Log the error for debugging purposes
        //     console.error('Error during navigation:', error.message);
        //     alert('An error occurred: ' + error.message); // Optional user alert
        // }
    }

    const localStation = JSON.parse(localStorage.getItem('Handler_stn'));
    useEffect(() => {
        if (isMounted.current) return;
        fetchUnLoadingStn();
        fetchLoadingStn();
        fetchSearchData();
        isMounted.current = true;
    }, []);

    // SEARCH START
    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results)
    }

    const handleOnHover = (result) => {
        // the item hovered
        console.log(result)
    }

    const handleOnSelect = async (item) => {
        // the item selected
        console.log(item)
        // try {
        //     const res = await withRFSToken.post(ULDSEARCHDETAILS, { uld_number: item.name });
        //     if (res.data.response_code == 200) {
        //         localStorage.removeItem('MHistory');
        //         const storageData = {
        //             ULD: res.data.response_data,  // ULD Details section
        //             Form: {}  // Empty form section
        //         };
        //         localStorage.setItem('MHistory', JSON.stringify(storageData));
        //         localStorage.setItem('tab', initialTab);
        //         window.location.href = '/ULDControl/MovementHistory'
        //     }

        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    }

    const handleOnFocus = () => {
        // console.log('Focused')
    }

    // DOWNLOAD START

    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);
    };

    const changeOrder = (e) => {
        const { name, value } = e.target;
        setOrderType(e.target.value);
    }

    const loadStation = async () => {
        try {
            const res = await withRFSToken.get('organization-station/list')
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const modifiedList = [
                        // {
                        //     label: 'All',
                        //     value: 0,
                        // },
                        ...innerData.map(w => ({
                            ...w,
                            label: w.station_name,
                            value: w.org_station_id,
                        })),
                    ];
                    setStationlist(modifiedList);
                });
        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    const handleStationChange = (selectedOption) => {
        setSelectedStation(selectedOption);
        const { value, label, ...filteredOption } = selectedOption;
        localStorage.setItem('Handler_stn', JSON.stringify(filteredOption));
        window.location.reload();
    };
    return (
        <div className="">
            {downloadOpen &&
                <DownloadGrid
                    download_area={user ? 'airline' : 'trucker'}
                    download_sec={selectedButton == 'vehicle' ? 'vehicle_view' : (selectedButton == 'orders' ? 'order_view' : (selectedButton == 'awb' ? 'awb_view' : ''))}
                    onClose={closeDownloadModal}
                />
            }
            <Header page_type='Handler' logo_url='/HandlerTruckMonitor' />
            <TopMenu module='SPL' />
            <div className="page-body-wrapper schedule">
                <LeftMenu />
                <div className="main-panel rounded">
                    <div className="mainTab">
                        <div className="">
                            <div className="allcontent-fl">
                                <div className='d-flex justify-content-between align-items-center mb-0'>
                                    <div>
                                        {/* {!user && */}
                                        <button className={selectedButton === 'vehicle' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('vehicle')}>
                                            {/* <img src={selectedButton === 'vehicle' ? Exportw : Export} /> <span>Vehicle View</span> */}
                                            <img src={selectedButton === 'vehicle' ? Exportw : Export} /> <span>Trip View</span>
                                        </button>
                                        {/* } */}
                                        <button className={selectedButton === 'orders' ? 'exportbtn active me-3' : 'exportbtn me-3'} onClick={() => handleButtonClick('orders')}>
                                            <img src={selectedButton === 'orders' ? Exportw : Export} /> <span>Orders View</span>
                                        </button>
                                        <button className={selectedButton === 'awb' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('awb')}>
                                            <img src={selectedButton === 'awb' ? Exportw : Export} /> <span>AWB View</span>
                                        </button>
                                    </div>
                                    <div className='view_filter'>
                                        {/* <div className='load_select'>
                                            <Form.Group>
                                                <Form.Select aria-label="Default select example" name='order_type' onChange={changeOrder} value={orderType}>
                                                    <option value='All'>All</option>
                                                    <option value='Loading'>Loading</option>
                                                    <option value="Unloading">Unloading</option>
                                                </Form.Select>

                                            </Form.Group>
                                        </div> */}
                                        {resetFilter && <Link className="reset_bg" to='#' onClick={handleResetFilter}><img src={Reset} /> Reset</Link>}
                                        {selectedButton === 'orders' &&
                                            <>
                                                <label>Switch Station</label>
                                                <Select
                                                    name="warehouse_id"
                                                    options={stationlist}
                                                    value={stationlist?.find(opt => opt.value == localStation.org_station_id)}
                                                    onChange={(val) => handleStationChange(val)}
                                                    placeholder="Station"
                                                />
                                            </>
                                            // <Dropdown>
                                            //     <Dropdown.Toggle variant="link" id="dropdown-basic" >
                                            //         <FontAwesomeIcon icon={faFilter} /> Filter
                                            //     </Dropdown.Toggle>
                                            //     <Dropdown.Menu className='filter_menu charter_from'>
                                            //         <div className='d-flex justify-content-between filter_text'><h3>Filter </h3>  <Link to='#' onClick={handleResetFilter}>Clear</Link></div>
                                            //         <Row>
                                            //             <Col md="6">
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Trucker Name</Form.Label>
                                            //                     <Form.Control
                                            //                         type="text"
                                            //                         placeholder=""
                                            //                         value={filterData.trucker_name}
                                            //                         onChange={(e) => {
                                            //                             // handleFieldChange(index, 'pieces', e.target.value);
                                            //                             setFilterData((prevFormData) => ({
                                            //                                 ...prevFormData,
                                            //                                 trucker_name: e.target.value
                                            //                             }));
                                            //                         }}
                                            //                     />
                                            //                     {/* <MultiSelect
                                            //                         options={getLoadingStn}
                                            //                         value={getLoadingStn.filter(item => filterData.loading_station?.includes(item.value)) || ''}
                                            //                         onChange={(selected) => {
                                            //                             const selectedIds = selected.map(item => item.value);
                                            //                             setFilterData((prevFormData) => ({
                                            //                                 ...prevFormData,
                                            //                                 loading_station: selectedIds
                                            //                             }));

                                            //                             const allLocations = selected.flatMap(item => item.location);
                                            //                             setSelectedLLocation(allLocations);
                                            //                         }}
                                            //                         labelledBy="Select "
                                            //                         className='multiselect'
                                            //                     /> */}
                                            //                 </Form.Group>
                                            //             </Col>
                                            //             <Col md="6">
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Trucker No.</Form.Label>
                                            //                     <Form.Control
                                            //                         type="text"
                                            //                         placeholder=""
                                            //                         value={filterData.truck_number}
                                            //                         onChange={(e) => {
                                            //                             // handleFieldChange(index, 'pieces', e.target.value);
                                            //                             setFilterData((prevFormData) => ({
                                            //                                 ...prevFormData,
                                            //                                 truck_number: e.target.value
                                            //                             }));
                                            //                         }}
                                            //                     />
                                            //                 </Form.Group>
                                            //             </Col>
                                            //         </Row>
                                            //         <Row>
                                            //             <Col sm='6'>
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Station</Form.Label>
                                            //                     <Form.Control
                                            //                         type="text"
                                            //                         placeholder=""
                                            //                         value={filterData.station}
                                            //                         onChange={(e) => {
                                            //                             // handleFieldChange(index, 'pieces', e.target.value);
                                            //                             setFilterData((prevFormData) => ({
                                            //                                 ...prevFormData,
                                            //                                 station: e.target.value
                                            //                             }));
                                            //                         }}
                                            //                     />
                                            //                 </Form.Group>
                                            //             </Col>
                                            //             <Col sm='6'>
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Vehicle Id</Form.Label>
                                            //                     <Form.Control
                                            //                         type="text"
                                            //                         placeholder=""
                                            //                         value={filterData.vehicle_id}
                                            //                         onChange={(e) => {
                                            //                             // handleFieldChange(index, 'pieces', e.target.value);
                                            //                             setFilterData((prevFormData) => ({
                                            //                                 ...prevFormData,
                                            //                                 vehicle_id: e.target.value
                                            //                             }));
                                            //                         }}
                                            //                     />
                                            //                 </Form.Group>
                                            //             </Col>
                                            //         </Row>
                                            //         <Row>
                                            //             <Col sm={6}>
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Docs</Form.Label>
                                            //                     {/* <Form.Control type="text" name='docs' onChange={handleFilterChange} value={filterData.docs || ''} /> */}
                                            //                     <Form.Select aria-label="Select" name='docs' onChange={handleFilterChange} value={filterData.docs || ''}>
                                            //                         <option value="">Select</option>
                                            //                         <option value='Open'>Open</option>
                                            //                         <option value='Processing'>Processing</option>
                                            //                         <option value='Completed'>Completed</option>
                                            //                     </Form.Select>
                                            //                 </Form.Group>
                                            //             </Col>
                                            //         </Row>
                                            //         {/* <Row>
                                            //             <Col>
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Truck Date </Form.Label>
                                            //                     <Form.Control type="date" name='truck_date' onChange={handleFilterChange} value={filterData.truck_date || ''} />
                                            //                 </Form.Group>
                                            //             </Col>
                                            //             <Col> */}
                                            //         {/* <Form.Group className="mb-1">
                                            //                     <Form.Label>Status</Form.Label>
                                            //                     <Form.Control type="text" name='pick_status' onChange={handleFilterChange} value={filterData.pick_status || ''} />
                                            //                 </Form.Group> */}
                                            //         {/* <Form.Group className="mb-1">
                                            //                     <Form.Label>Truck No. </Form.Label>
                                            //                     <Form.Control type="text" name='truck_number' onChange={handleFilterChange} value={filterData.truck_number || ''} />
                                            //                 </Form.Group>
                                            //             </Col>
                                            //         </Row> */}
                                            //         {/* <Row>
                                            //             <Col>
                                            //                 <Form.Group className="mb-1">
                                            //                     <Form.Label>Order No. </Form.Label>
                                            //                     <Form.Control type="text" name='order_number' onChange={handleFilterChange} value={filterData.order_number || ''} />
                                            //                 </Form.Group>
                                            //             </Col>
                                            //             <Col>

                                            //             </Col>
                                            //         </Row> */}

                                            //         <div className="mt-3 text-end"><Button variant="primary" className='adduld m-0' onClick={handleApplyFilter}>Apply Filter</Button></div>
                                            //     </Dropdown.Menu>
                                            // </Dropdown>
                                        }

                                        <Dropdown onToggle={(isOpen) => { if (!isOpen) { clearSearch(); } }}>
                                            <Dropdown.Toggle variant="link" id="dropdown-basic" >
                                                <FontAwesomeIcon icon={faMagnifyingGlass} /> Search
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='filter_menu charter_from'>
                                                <div className='d-flex justify-content-between filter_text'><h3>Search </h3>  <Link to='#' onClick={clearSearch}>Clear</Link></div>
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-1">
                                                            <Form.Label>Search Area</Form.Label>
                                                            <Form.Select aria-label="Default select example" value={searchData.search_area} name='search_area' onChange={handleSearchChange}>
                                                                <option value=''>Select</option>
                                                                <option value="o">Orders No.</option>
                                                                <option value="a">AWB No.</option>
                                                            </Form.Select>

                                                        </Form.Group>
                                                    </Col>
                                                    <Col>

                                                    </Col>
                                                </Row>
                                                {searchData.search_area &&
                                                    <Row>
                                                        <Col>
                                                            <Form.Group className="mb-1">
                                                                <Form.Label>Select {searchData.search_area == 'o' ? 'Order' : 'AWB'} Number</Form.Label>
                                                                {/* <Form.Control type="text" onChange={handleSearchChange} /> */}
                                                                <Select
                                                                    options={searchData.search_area == 'o' ? searchItems.orderList : searchData.search_area == 'a' ? searchItems.awbList : []}
                                                                    placeholder="Select number"
                                                                    className='down_selct'
                                                                    onChange={(selected) => {
                                                                        setSearchData({ ...searchData, o_id: selected.value, o_label: selected.label });
                                                                    }}
                                                                    // isMulti
                                                                    // name="status"
                                                                    value={(searchData.search_area == 'o' ? searchItems.orderList : searchData.search_area == 'a' ? searchItems.awbList : []).find(value => value.label === searchData.o_label) || ''}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                }
                                                <div className="mt-3 text-end"><Button variant="primary" className='adduld m-0' onClick={handleSearch}>Search</Button></div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        {/* <Link to='#'><FontAwesomeIcon icon={faMagnifyingGlass} /> Search  </Link> */}
                                        {/* <Link><FontAwesomeIcon icon={faFilter} /> Filter </Link> */}
                                        {/* <div className="form-group has-search">

                                            <ReactSearchAutocomplete
                                                items={searchItems}
                                                onSearch={handleOnSearch}
                                                onHover={handleOnHover}
                                                onSelect={handleOnSelect}
                                                onFocus={handleOnFocus}
                                                autoFocus
                                                placeholder="Search ULD"
                                            // formatResult={formatResult}
                                            />
                                        </div> */}

                                        <Link to='#' onClick={showDownloadModal}><FontAwesomeIcon icon={faDownload} /> Download </Link>


                                    </div>
                                </div>
                                <div className="lcontent">
                                    {selectedButton === 'vehicle' &&
                                        <VehicleView />
                                    }
                                    {selectedButton === 'orders' &&
                                        <OrdersView filterData={filterData} applyFilter={applyFilter} setApplyFilter={setApplyFilter} resetGrid={resetFilters} order_type={orderType} selectedStation={selectedStation} />
                                    }
                                    {selectedButton === 'awb' &&
                                        <AwbView />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TruckMonitor;